var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as _ from 'lodash';
import { Component, ViewChild } from '@angular/core';
import { FontElementSettingModal } from '../base/font-element-setting-modal';
var TextSettingModalComponent = /** @class */ (function (_super) {
    __extends(TextSettingModalComponent, _super);
    function TextSettingModalComponent(injector) {
        return _super.call(this, injector, 'textSettingModal') || this;
    }
    TextSettingModalComponent.prototype.onShown = function () {
        $(this.textInput.nativeElement).focus();
    };
    TextSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        var componentData = editedComponent.model.data;
        this.configureId = editedComponent.configureId;
        this.loadFontInfo(componentData);
        this.loadGraphSetting(componentData);
        this.text = componentData.text;
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
    };
    TextSettingModalComponent.prototype.saveText = function () {
        this.saveComponentProperty('text', this.text);
    };
    TextSettingModalComponent.prototype.save = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('text settings');
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(2);
            return;
        }
        this.saveFontInfo();
        this.saveGraphSetting();
        this.saveText();
        this.currentDiagram.commitTransaction('text settings');
        this.close();
    };
    TextSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    TextSettingModalComponent.prototype.loadGraphSetting = function (componentData) {
        this.useGraph = componentData.useGraph;
        if (null != componentData.graphSetting) {
            this.graphSetting = _.cloneDeep(componentData.graphSetting);
        }
        else {
            this.graphSetting = {};
        }
    };
    TextSettingModalComponent.prototype.saveGraphSetting = function () {
        this.saveComponentProperty('useGraph', this.useGraph);
        if (this.useGraph) {
            this.saveComponentProperty('graphSetting', this.graphSetting);
        }
        else {
            this.deleteComponentProperty('graphSetting');
        }
        this.deleteComponentProperty('graphUrl');
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], TextSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], TextSettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        ViewChild('textInput', { static: false })
    ], TextSettingModalComponent.prototype, "textInput", void 0);
    TextSettingModalComponent = __decorate([
        Component({
            selector: 'text-setting-modal',
            styles: [".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"textSettingModal\" class=\"modal fade textSettingModal date-time-setting-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" (onShown)=\"onShown()\" aria-hidden=\"true\" (onHidden)=\"onHidden()\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\"> <div class=\"modal-content element-setting-base\"> <div class=\"fe-modal-container\"> <form class=\"configure\" *ngIf=\"active\" #textAttributeForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <div class=\"fe-modal-header-title\"> {{lc(\"Text\")}} </div> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle valueShow\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Text')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"fe-vertical-label\"> <font-style [(fontSize)]=\"fontSize\" [(fontColor)]=\"fontColor\" [(textAlign)]=\"textAlign\" [(isUnderline)]=\"isUnderline\" [(fontStyle)]=\"fontStyle\"></font-style> </div> <div class=\"fe-vertical-label margin-top-20\" style=\"height: 145px;\"> <textarea class=\"whole-width noResize\" rows=\"6\" name=\"text\" #textInput required maxlength=\"500\" [(ngModel)]=\"text\"> </textarea> </div> </div> </tab> <tab heading=\"{{lc('Graph')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(graphSettingEventName)\"> <graph-setting [configureId]=\"configureId\" [(useGraph)]=\"useGraph\" [graphSetting]=\"graphSetting\"></graph-setting> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!textAttributeForm.form.valid\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        })
    ], TextSettingModalComponent);
    return TextSettingModalComponent;
}(FontElementSettingModal));
export { TextSettingModalComponent };
